"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var DlgPwdChangeSelf = /** @class */ (function (_super) {
    __extends(DlgPwdChangeSelf, _super);
    function DlgPwdChangeSelf(props) {
        return _super.call(this, props) || this;
    }
    DlgPwdChangeSelf.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                oldPass: data.oldPass,
                newPass: data.newPass,
                repeatNewPass: data.repeatNewPass
            });
        });
        this.setState({
            visible: this.props.controller.DATA.visible,
            oldPass: this.props.controller.DATA.oldPass,
            newPass: this.props.controller.DATA.newPass,
            repeatNewPass: this.props.controller.DATA.repeatNewPass
        });
    };
    DlgPwdChangeSelf.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgPwdChangeSelf.prototype.handleYes = function () {
        if (this.state.oldPass.length <= 0) {
            this.props.errDialog.SetTitle("ОШИБКА ИЗМЕНЕНИЯ ПАРОЛЯ").SetMessage("СТАРЫЙ ПАРОЛЬ ПУСТОЙ").Show();
            return;
        }
        if (this.state.newPass.length <= 0) {
            this.props.errDialog.SetTitle("ОШИБКА ИЗМЕНЕНИЯ ПАРОЛЯ").SetMessage("НОВЫЙ ПАРОЛЬ ПУСТОЙ").Show();
            return;
        }
        if (this.state.repeatNewPass.length <= 0) {
            this.props.errDialog.SetTitle("ОШИБКА ИЗМЕНЕНИЯ ПАРОЛЯ").SetMessage("НОВЫЙ ПОВТОРНЫЙ ПАРОЛЬ ПУСТОЙ").Show();
            return;
        }
        if (this.state.repeatNewPass != this.state.newPass) {
            this.props.errDialog.SetTitle("ОШИБКА ИЗМЕНЕНИЯ ПАРОЛЯ").SetMessage("ПАРОЛИ НЕ СОВПАДАЮТ").Show();
            return;
        }
        this.props.controller.DATA.oldPass = this.state.oldPass;
        this.props.controller.DATA.newPass = this.state.newPass;
        this.props.controller.DATA.repeatNewPass = this.state.repeatNewPass;
        this.props.controller.Close();
        if (this.props.controller.DATA.onYes) {
            this.props.controller.DATA.onYes(this.state.oldPass, this.state.newPass);
        }
    };
    DlgPwdChangeSelf.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgPwdChangeSelf.prototype.OnOldPassChanged = function (e) {
        this.setState({ oldPass: e.target.value });
    };
    DlgPwdChangeSelf.prototype.OnNewPassChanged = function (e) {
        this.setState({ newPass: e.target.value });
    };
    DlgPwdChangeSelf.prototype.OnRepeatNewPassChanged = function (e) {
        this.setState({ repeatNewPass: e.target.value });
    };
    DlgPwdChangeSelf.prototype.render = function () {
        return React.createElement(antd_1.Modal, { title: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u043F\u0430\u0440\u043E\u043B\u044F", visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: false, maskClosable: false, okType: "primary" },
            React.createElement("div", null,
                React.createElement("div", { style: { marginBottom: 16 } },
                    React.createElement(antd_1.Popover, { placement: "bottom", content: React.createElement("div", null, "Введите текущий пароль"), trigger: "hover" },
                        React.createElement(antd_1.Input, { addonBefore: React.createElement(antd_1.Icon, { type: "key" }), type: "password", placeholder: "\u0422\u0435\u043A\u0443\u0449\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C", onChange: this.OnOldPassChanged.bind(this), value: this.state.oldPass }))),
                React.createElement("div", { style: { marginBottom: 16 } },
                    React.createElement(antd_1.Popover, { placement: "bottom", content: React.createElement("div", null, "Введите новый пароль"), trigger: "hover" },
                        React.createElement(antd_1.Input, { addonBefore: React.createElement(antd_1.Icon, { type: "key" }), type: "password", placeholder: "\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C", onChange: this.OnNewPassChanged.bind(this), value: this.state.newPass }))),
                React.createElement("div", null,
                    React.createElement(antd_1.Popover, { placement: "bottom", content: React.createElement("div", null, "Введите повторно новый пароль"), trigger: "hover" },
                        React.createElement(antd_1.Input, { addonBefore: React.createElement(antd_1.Icon, { type: "key" }), type: "password", placeholder: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C", onChange: this.OnRepeatNewPassChanged.bind(this), value: this.state.repeatNewPass })))));
    };
    return DlgPwdChangeSelf;
}(React.Component));
exports.default = DlgPwdChangeSelf;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ui/DlgPwdChangeSelf.tsx
// module id = 1718
// module chunks = 0